import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared';
import { ClientePreBaixaCardInfoComponent } from './card-info';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClientePreBaixaCardInfoComponent
    ],
    exports: [
        ClientePreBaixaCardInfoComponent
    ]
})
export class ClientePreBaixaModule { }
